import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Teleport as _Teleport, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4de4162c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "AppOverlay AppOverlay--dust fixed inset-0 z-overlay bg-cover bg-center opacity-80 mix-blend-exclusion pointer-events-none" }, null, -1));
import { computed, defineAsyncComponent, onMounted, ref, watchEffect } from "vue";
import { useAppContext, useAppState } from "@/services/Composition";
import AppService from "@/services/AppService";
import Viewport from "@/store/modules/Viewport";
import Cursor from "@/store/modules/Cursor";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const { state } = useAppState();
        const LazyGLView = defineAsyncComponent(() => import("./components/GLView.vue"));
        const LazyTestStateMachine = defineAsyncComponent(() => import("./components/TestStateMachine.vue"));
        const LazyDIT = defineAsyncComponent(() => import("./components/pages/DIT.vue"));
        const LazyPopinPortraitMode = defineAsyncComponent(() => import("./components/Popin/PopinPortraitMode.vue"));
        const LazyPopinLowBatteryMode = defineAsyncComponent(() => import("./components/Popin/PopinLowBatteryMode.vue"));
        const debug = ref(process.env.VUE_APP_DEBUG === "true");
        const showPreloader = ref(process.env.VUE_APP_SKIP_INTRO !== "true");
        const isPreloader = computed(() => ["initial", "create_activities", "loading", "loaded"].some(state.value.matches));
        const isHome = computed(() => ["home.landing", "home.home.page"].some(state.value.matches));
        const isDit = computed(() => state.value.matches("dit"));
        const isStory = computed(() => state.value.matches("story"));
        const isAbout = computed(() => state.value.matches("home.home.about"));
        const isCredits = computed(() => state.value.matches("end"));
        const isSms = useAppContext("childSMCreated");
        const showLowPowerMode = ref(false);
        const checkLowPowerMode = async () => {
            const testVideo = document.createElement("video");
            testVideo.setAttribute("playsinline", "playsinline");
            testVideo.setAttribute("aria-hidden", "true");
            testVideo.setAttribute("src", "");
            const isLowPowerMode = (await import("./utils/PowerMode")).default;
            isLowPowerMode(testVideo).then((lowPower) => {
                // @todo: fix for mobile then uncomment
                // showLowPowerMode.value = lowPower;
            });
        };
        const showPortraitMode = computed(() => Viewport.isMobile && Viewport.isLandscape);
        const fontLoaded = ref(false);
        const glappCreated = ref(false);
        const isMounted = ref(false);
        const onFontLoaded = () => (fontLoaded.value = true);
        watchEffect(() => {
            document.documentElement.classList.toggle("cursor-none", Cursor.visible);
        });
        onMounted(async () => {
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.finally(onFontLoaded);
            }
            else {
                onFontLoaded();
            }
            // checkLowPowerMode();
            await AppService.start();
            glappCreated.value = true;
            isMounted.value = true;
        });
        return (_ctx, _cache) => {
            const _component_Home = _resolveComponent("Home");
            const _component_Story = _resolveComponent("Story");
            const _component_About = _resolveComponent("About");
            const _component_Credits = _resolveComponent("Credits");
            const _component_AppLayout = _resolveComponent("AppLayout");
            const _component_AppPreloader = _resolveComponent("AppPreloader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (fontLoaded.value && _unref(isSms))
                    ? (_openBlock(), _createBlock(_component_AppLayout, { key: 0 }, {
                        default: _withCtx(() => [
                            (glappCreated.value)
                                ? (_openBlock(), _createBlock(_unref(LazyGLView), { key: 0 }))
                                : _createCommentVNode("", true),
                            (debug.value)
                                ? (_openBlock(), _createBlock(_unref(LazyTestStateMachine), { key: 1 }))
                                : _createCommentVNode("", true),
                            (isHome.value)
                                ? (_openBlock(), _createBlock(_component_Home, { key: 2 }))
                                : (isStory.value)
                                    ? (_openBlock(), _createBlock(_component_Story, { key: 3 }))
                                    : (isDit.value)
                                        ? (_openBlock(), _createBlock(_unref(LazyDIT), { key: 4 }))
                                        : (isAbout.value)
                                            ? (_openBlock(), _createBlock(_component_About, { key: 5 }))
                                            : (isCredits.value)
                                                ? (_openBlock(), _createBlock(_component_Credits, { key: 6 }))
                                                : _createCommentVNode("", true),
                            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                                (showPortraitMode.value)
                                    ? (_openBlock(), _createBlock(_unref(LazyPopinPortraitMode), { key: 0 }))
                                    : (showLowPowerMode.value)
                                        ? (_openBlock(), _createBlock(_unref(LazyPopinLowBatteryMode), { key: 1 }))
                                        : _createCommentVNode("", true)
                            ]))
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (showPreloader.value)
                    ? _withDirectives((_openBlock(), _createBlock(_component_AppPreloader, {
                        key: 1,
                        onAfterLeave: _cache[0] || (_cache[0] = ($event) => (showPreloader.value = false))
                    }, null, 512)), [
                        [_vShow, isPreloader.value]
                    ])
                    : _createCommentVNode("", true),
                _hoisted_1
            ], 64));
        };
    }
});
